export enum SalutationEnum {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    PREFER_NOT_SAY = 'PREFER_NOT_SAY'
}
